/* resources/assets/js/institution/features/statisticsmanagement/TestResults.vue */
/* resources/assets/js/features/MainContentArea/MainContentArea.vue */

import uniq from 'ramda/es/uniq'
import {TestTemplate, TestState, TestResults, MainCategories, SubCategories, Answer} from 'Models'
import {ThemeMixin} from 'Mixins'


export default {
    mixins: [ThemeMixin],

    computed: {
        testDurationType()  { return TestState.isRealTest() ? TestTemplate.durationType() : '' },
        startTime()         { return TestResults.startTime() },
        endTime()           { return TestResults.endTime() },
        userAnswers()       { return Answer.userAnswers() },
        currentSubCategory(){ return SubCategories.getSelected() },

        mainCategories()
        {
            const mainCatIDs            = this.userAnswers.map( ua => ua.mainCategoryId())
            const createMainCatFromID   =  id => MainCategories.createFromId(id)

            return uniq( mainCatIDs ).map( createMainCatFromID )
        },

        subCategories()
        {
            const subCatIDs             = this.userAnswers.map( ua => ua.subCategoryId())
            const createSubCatFromID    = id => SubCategories.createFromId(id)

            return uniq( subCatIDs ).map( createSubCatFromID )
        },
    },

    created() {
        const scrollUp = () => this.scrollUp()
        this.$ebus.onChangingBlock(scrollUp)
        this.$ebus.onChangingSubCategory(scrollUp)
        this.$ebus.onChangingMainCategory(scrollUp)
        this.$ebus.onGoToNextQuestion(scrollUp)
        this.$ebus.onGoToPreviousQuestion(scrollUp)
        this.$ebus.onGoToQuestionNumber(scrollUp)
    },

    methods: {
        scrollUp() {
            if(this.$refs.question)
                this.$refs.question.scrollTop = 0
        }
    }
}